import { jsx as _jsx } from "react/jsx-runtime";
import { isNil } from "lodash";
import { EMPTY_VALUE } from "../../../../constants/common";
export const parseAttributeValue = (value) => {
    if (isNil(value)) {
        return EMPTY_VALUE;
    }
    if (typeof value === "string") {
        if (value === "") {
            return EMPTY_VALUE;
        }
        if (value.startsWith("http://") || value.startsWith("https://")) {
            return _jsx("a", { href: value, rel: "noreferrer", target: "_blank", children: value });
        }
    }
    return value;
};
